export default __webpack_public_path__ + "static/media/avatar.43ebe323.jpg";